import React, { useEffect } from "react";
import { Layout } from "antd";
import { IntercomProvider } from "react-use-intercom";
import { useDispatch, useSelector } from "react-redux";
import { without, keys } from "lodash";

import MainHeader from "../Header/Main";
import "./Main.scss";

import { DEFAULT_TRANSLATION } from "../../constants";
import { doLanguageTranslateNoFetching, doUpdateSettingNoFetching } from "../../modules/setting/stores/thunk";

const { Content } = Layout;
const INTERCOM_APP_ID = "dqrxzlr9";

const MainLayout = ({ children, auth }) => {
  const { user } = auth || {};
  const { translation, systemLanguage } = user?.company || {};
  const { translate } = useSelector(state => state.setting);

  const dispatch = useDispatch();
  const positions = keys(DEFAULT_TRANSLATION);

  const checkIsMissFields = () => {
    if (systemLanguage === "en" || !translation?.[systemLanguage]) return false;
    for (const position of positions) {
      const positionKeys = keys(translation?.[systemLanguage]?.[position]);
      const defaultKeys = keys(DEFAULT_TRANSLATION[position]);
      console.log(without(defaultKeys, ...positionKeys));
      if (without(defaultKeys, ...positionKeys).length > 0) return true;
    }
    return false;
  };

  useEffect(() => {
    if (translate && checkIsMissFields()) {
      const params = { translation: { ...translation } };
      params.translation[systemLanguage] = { ...translation[systemLanguage] };
      for (const position of positions) {
        params.translation[systemLanguage][position] = {
          ...translate[position],
          ...translation[systemLanguage][position],
        };
      }
      dispatch(doUpdateSettingNoFetching(params));
    }
  }, [translate]);

  useEffect(() => {
    if (checkIsMissFields()) {
      dispatch(
        doLanguageTranslateNoFetching({
          text: DEFAULT_TRANSLATION,
          to: systemLanguage,
        }),
      );
    }
  }, [translation, systemLanguage]);

  return (
    <IntercomProvider appId={INTERCOM_APP_ID}>
      <Layout className="MainLayout">
        <MainHeader user={user} />
        <Content className="site-layout" style={{ marginTop: 52 }}>
          {children}
        </Content>
      </Layout>
    </IntercomProvider>
  );
};

export default MainLayout;
